// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .flex-container {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  align-content: stretch;
}

::ng-deep .flex-child {
  flex: 1 0 15%;
  align-self: center;
  display: flex;
  justify-content: space-evenly;
}

.flex-child-long {
  flex-grow: 12;
}

textarea {
  width: 100%;
}

li {
  margin-bottom: 3px;
}

.color-red {
  color:#c0392b;
}

.customTable {
  overflow: auto;
  border: 1px solid lightgray;
  min-height:160px;
  max-height:160px;
}

/** Placeholder **/
.placeholder-description {
  background-color: transparent;
  color: white;
  padding: 10px;
  border: none;
  transition: border 0.3s;
  width: 100%;
}

.placeholder-description::placeholder {
  color: white;
  font-size: 0.8em;
}


.modal-body {
  background-color: #FFFFFF;
}

.btn-modal-event-off-duty, .btn-modal-event-train, .btn-modal-event-sick, .btn-modal-event-kids, .btn-modal-event-phol, .btn-modal-event-oth,
.btn-modal-event-techz, .btn-modal-event-trainz, .btn-modal-event-confz, .btn-modal-event-casualz, .btn-modal-event-hbw {
  font-weight: 400;
  text-transform: none;
  padding-top: 55px;
}

agm-map {
  height: 300px;
}

.background-color-off {
  background-color: #f39c12; /* Off duty color */
  transition: background ease-out .2s;
}

.background-color-sick {
  background-color: #c0392b; /* Sick color */
  transition: background ease-out .2s;
}

.background-color-kids {
  background-color: #d46659; /* kids color */
  transition: background ease-out .2s;
}

.background-color-train {
  background-color: #9b59b6; /* Training color */
  transition: background ease-out .2s;
}

.background-color-oth {
  background-color: #1abc9c; /* Other color */
  transition: background ease-out .2s;
}

.background-color-confz {
  background-color: #fe8f60; /* Conf'z color */
  transition: background ease-out .2s;
}

.background-color-trainz {
  background-color: #9895ee; /* Train'z color */
  transition: background ease-out .2s;
}

.background-color-casualz {
  background-color: #1ec7be; /* Cazual'z color */
  transition: background ease-out .2s;
}

.background-color-techz {
  background-color: #9BCD5F; /* Tech'z color */
  transition: background ease-out .2s;
}

.ui-togglebutton.ui-button.ui-state-default,
.ui-selectbutton .ui-button.ui-state-default {
    border: none;
	background: #ffffff;
	color: #0077B5;
}

.ui-togglebutton.ui-button.ui-state-hover,.ui-togglebutton.ui-button.ui-state-focus,
.ui-selectbutton .ui-button.ui-state-hover,.ui-selectbutton .ui-button.ui-state-focus {
   background: rgba(0,0,0,.07);
   color: #0077B5;
}

.ui-togglebutton.ui-button.ui-state-active,
.ui-selectbutton .ui-button.ui-state-active {
   background: #0077B5;
   color: #FFFFFF;
}

.ui-selectbutton .ui-button:first-child {
	border-radius: 2px 0 0 2px;
}
.ui-selectbutton .ui-button:last-child {
	border-radius: 0 2px 2px 0	;
}

/** Selected button **/
::ng-deep .p-button {
  white-space: nowrap;
  font-size: 14px;
}

::ng-deep .p-component {
  background-color: #ffffff;
  color: #3498db;
  border-radius: 2px;
  padding: .3em 1em;
}

::ng-deep .p-component.p-highlight{
  background-color: #3498db;
  color: #ffffff !important;
  border-radius: 2px;
  padding: .3em 1em;
}


/** Datepicker **/
::ng-deep .custom-p-calendar-input {
  width: auto;
  border: 1px solid #ccc;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 10000 !important;
}

::ng-deep .p-datepicker {
  color: #333;
}

::ng-deep .p-datepicker-header {
  padding: 10px;
  color: #333;
}

::ng-deep.p-datepicker-title {
	margin: 6px 35px;
  display: flex;
  justify-content: space-between;
}

::ng-deep .p-datepicker-title .p-datepicker-year {
	margin-left: 6px;
}

::ng-deep .p-datepicker table th {
  background-color: #E0E0E0;
  padding: 5px;
}

::ng-deep .p-datepicker table td > span {
  background-color: #ffffff;
  padding: 10px;
}

::ng-deep .p-datepicker table td:hover > span {
  background-color: #E0E0E0;
  color: #ffffff;
  padding: 8px;
  border-radius: 50%;
  outline: 1px solid #E0E0E0;
}

::ng-deep .p-datepicker table td.p-datepicker-today > span {
  background-color: #0077B5;
  color: #ffffff;
  padding: 8px;
  border-radius: 50%;
  outline: 1px solid #0077B5;
}

::ng-deep .p-datepicker table td.p-datepicker-other-month > span {
  color: #E0E0E0;
}

::ng-deep .p-datepicker table td.p-datepicker-other-month:hover > span {
  background-color: #EEEEEE;
  color: #ffffff;
  padding: 8px;
  border-radius: 50%;
  outline: 1px solid #EEEEEE;
}

::ng-deep span.p-disabled {
  color: #d3d3d3;
}
`, "",{"version":3,"sources":["webpack://./src/app/Components/EventManagement/eventmanagement.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,6BAA6B;EAC7B,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;;AAGA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB,EAAE,mBAAmB;EAC9C,mCAAmC;AACrC;;AAEA;EACE,yBAAyB,EAAE,eAAe;EAC1C,mCAAmC;AACrC;;AAEA;EACE,yBAAyB,EAAE,eAAe;EAC1C,mCAAmC;AACrC;;AAEA;EACE,yBAAyB,EAAE,mBAAmB;EAC9C,mCAAmC;AACrC;;AAEA;EACE,yBAAyB,EAAE,gBAAgB;EAC3C,mCAAmC;AACrC;;AAEA;EACE,yBAAyB,EAAE,iBAAiB;EAC5C,mCAAmC;AACrC;;AAEA;EACE,yBAAyB,EAAE,kBAAkB;EAC7C,mCAAmC;AACrC;;AAEA;EACE,yBAAyB,EAAE,mBAAmB;EAC9C,mCAAmC;AACrC;;AAEA;EACE,yBAAyB,EAAE,iBAAiB;EAC5C,mCAAmC;AACrC;;AAEA;;IAEI,YAAY;CACf,mBAAmB;CACnB,cAAc;AACf;;AAEA;;GAEG,2BAA2B;GAC3B,cAAc;AACjB;;AAEA;;GAEG,mBAAmB;GACnB,cAAc;AACjB;;AAEA;CACC,0BAA0B;AAC3B;AACA;CACC,2BAA2B;AAC5B;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;;AAGA,iBAAiB;AACjB;EACE,WAAW;EACX,sBAAsB;EACtB,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;CACC,gBAAgB;EACf,aAAa;EACb,8BAA8B;AAChC;;AAEA;CACC,gBAAgB;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB","sourcesContent":["::ng-deep .flex-container {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: baseline;\n  align-content: stretch;\n}\n\n::ng-deep .flex-child {\n  flex: 1 0 15%;\n  align-self: center;\n  display: flex;\n  justify-content: space-evenly;\n}\n\n.flex-child-long {\n  flex-grow: 12;\n}\n\ntextarea {\n  width: 100%;\n}\n\nli {\n  margin-bottom: 3px;\n}\n\n.color-red {\n  color:#c0392b;\n}\n\n.customTable {\n  overflow: auto;\n  border: 1px solid lightgray;\n  min-height:160px;\n  max-height:160px;\n}\n\n/** Placeholder **/\n.placeholder-description {\n  background-color: transparent;\n  color: white;\n  padding: 10px;\n  border: none;\n  transition: border 0.3s;\n  width: 100%;\n}\n\n.placeholder-description::placeholder {\n  color: white;\n  font-size: 0.8em;\n}\n\n\n.modal-body {\n  background-color: #FFFFFF;\n}\n\n.btn-modal-event-off-duty, .btn-modal-event-train, .btn-modal-event-sick, .btn-modal-event-kids, .btn-modal-event-phol, .btn-modal-event-oth,\n.btn-modal-event-techz, .btn-modal-event-trainz, .btn-modal-event-confz, .btn-modal-event-casualz, .btn-modal-event-hbw {\n  font-weight: 400;\n  text-transform: none;\n  padding-top: 55px;\n}\n\nagm-map {\n  height: 300px;\n}\n\n.background-color-off {\n  background-color: #f39c12; /* Off duty color */\n  transition: background ease-out .2s;\n}\n\n.background-color-sick {\n  background-color: #c0392b; /* Sick color */\n  transition: background ease-out .2s;\n}\n\n.background-color-kids {\n  background-color: #d46659; /* kids color */\n  transition: background ease-out .2s;\n}\n\n.background-color-train {\n  background-color: #9b59b6; /* Training color */\n  transition: background ease-out .2s;\n}\n\n.background-color-oth {\n  background-color: #1abc9c; /* Other color */\n  transition: background ease-out .2s;\n}\n\n.background-color-confz {\n  background-color: #fe8f60; /* Conf'z color */\n  transition: background ease-out .2s;\n}\n\n.background-color-trainz {\n  background-color: #9895ee; /* Train'z color */\n  transition: background ease-out .2s;\n}\n\n.background-color-casualz {\n  background-color: #1ec7be; /* Cazual'z color */\n  transition: background ease-out .2s;\n}\n\n.background-color-techz {\n  background-color: #9BCD5F; /* Tech'z color */\n  transition: background ease-out .2s;\n}\n\n.ui-togglebutton.ui-button.ui-state-default,\n.ui-selectbutton .ui-button.ui-state-default {\n    border: none;\n\tbackground: #ffffff;\n\tcolor: #0077B5;\n}\n\n.ui-togglebutton.ui-button.ui-state-hover,.ui-togglebutton.ui-button.ui-state-focus,\n.ui-selectbutton .ui-button.ui-state-hover,.ui-selectbutton .ui-button.ui-state-focus {\n   background: rgba(0,0,0,.07);\n   color: #0077B5;\n}\n\n.ui-togglebutton.ui-button.ui-state-active,\n.ui-selectbutton .ui-button.ui-state-active {\n   background: #0077B5;\n   color: #FFFFFF;\n}\n\n.ui-selectbutton .ui-button:first-child {\n\tborder-radius: 2px 0 0 2px;\n}\n.ui-selectbutton .ui-button:last-child {\n\tborder-radius: 0 2px 2px 0\t;\n}\n\n/** Selected button **/\n::ng-deep .p-button {\n  white-space: nowrap;\n  font-size: 14px;\n}\n\n::ng-deep .p-component {\n  background-color: #ffffff;\n  color: #3498db;\n  border-radius: 2px;\n  padding: .3em 1em;\n}\n\n::ng-deep .p-component.p-highlight{\n  background-color: #3498db;\n  color: #ffffff !important;\n  border-radius: 2px;\n  padding: .3em 1em;\n}\n\n\n/** Datepicker **/\n::ng-deep .custom-p-calendar-input {\n  width: auto;\n  border: 1px solid #ccc;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  z-index: 10000 !important;\n}\n\n::ng-deep .p-datepicker {\n  color: #333;\n}\n\n::ng-deep .p-datepicker-header {\n  padding: 10px;\n  color: #333;\n}\n\n::ng-deep.p-datepicker-title {\n\tmargin: 6px 35px;\n  display: flex;\n  justify-content: space-between;\n}\n\n::ng-deep .p-datepicker-title .p-datepicker-year {\n\tmargin-left: 6px;\n}\n\n::ng-deep .p-datepicker table th {\n  background-color: #E0E0E0;\n  padding: 5px;\n}\n\n::ng-deep .p-datepicker table td > span {\n  background-color: #ffffff;\n  padding: 10px;\n}\n\n::ng-deep .p-datepicker table td:hover > span {\n  background-color: #E0E0E0;\n  color: #ffffff;\n  padding: 8px;\n  border-radius: 50%;\n  outline: 1px solid #E0E0E0;\n}\n\n::ng-deep .p-datepicker table td.p-datepicker-today > span {\n  background-color: #0077B5;\n  color: #ffffff;\n  padding: 8px;\n  border-radius: 50%;\n  outline: 1px solid #0077B5;\n}\n\n::ng-deep .p-datepicker table td.p-datepicker-other-month > span {\n  color: #E0E0E0;\n}\n\n::ng-deep .p-datepicker table td.p-datepicker-other-month:hover > span {\n  background-color: #EEEEEE;\n  color: #ffffff;\n  padding: 8px;\n  border-radius: 50%;\n  outline: 1px solid #EEEEEE;\n}\n\n::ng-deep span.p-disabled {\n  color: #d3d3d3;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
